import { Link, useNavigate } from "react-router-dom";
import cartIcon from "../../assets/images/cart-icon.svg";
import profileIcon from "../../assets/images/profile-icon.svg";
import searchIcon from "../../assets/images/search-icon.svg";
import "./header.css";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faClose } from "@fortawesome/free-solid-svg-icons";
import { useDispatch } from "react-redux";
import { searchProducts } from "../../features/product/productThunks";

export default function Header() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [query, setQuery] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const handleChange = () => {
    setIsOpen((prev) => !prev);
  };

  const handleSearch = () => {
    const trimmedQuery = query.trim();
    if (!trimmedQuery) return;

    dispatch(searchProducts({ query: trimmedQuery, page: 1 }));
    navigate(`/search?query=${encodeURIComponent(trimmedQuery)}&page=1`);
  };

  return (
    <div className="header-nav">
      <Link to="/" className="header-main-link">SHOP.CO</Link>

      <div className={`header-nav-links ${isOpen ? "open" : ""}`}>
        <Link className="header-link" to="/view-all-onSale" onClick={handleChange}>Onsale</Link>
        <Link className="header-link" to="/view-all-trending" onClick={handleChange}>Trending</Link>
        <Link className="header-link" to="/brands" onClick={handleChange}>Brands</Link>
        <Link className="header-link" to="/view-all-newArrivals" onClick={handleChange}>New Arrivals</Link>
      </div>

      <div className="header_search-div">
        <input
          className="header-search-input"
          type="text"
          placeholder="Search for a product..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleSearch();
            }
          }}
        />
        <img
          className="header-search-icon"
          src={searchIcon}
          alt="search"
          onClick={handleSearch}
        />
      </div>

      <div className="header-nav-icons">
        <FontAwesomeIcon
          className="header-menu"
          icon={isOpen ? faClose : faBars}
          onClick={handleChange}
        />
        <Link className="header-icon" to="/coming-soon">
          <img className="header-cart-icon" src={cartIcon} alt="cart-icon" />
        </Link>
        <Link className="header-profile header-icon" to="/coming-soon">
          <img className="header-profile-icon" src={profileIcon} alt="profile-icon" />
        </Link>
      </div>
    </div>
  );
}
